export class Page<T> {
    elements: T[];
    currentPage: number;
    totalPages: number;
    static pageSize: number = 10;

    constructor(elements: T[], totalPages: number, currentPage: number) {
        this.elements = elements;
        this.currentPage = currentPage;
        this.totalPages = totalPages;
    }
}
